

export const Loading = () => {
  return (
    <div className="loading-map d-flex justify-content-center aling-items-center">
        <div className="text-center">
            <h3>Espere Por favor </h3>
            <span>Localizando...</span>
        </div>
    </div>
  )
}
